import { useContext, useEffect, useRef } from 'react';

import IconDiscord from 'components/icons/IconDiscord';
import { useTranslationsContext } from 'contexts/translationsContext';
import { UserContext } from 'contexts/userContext';
import { getDiscordUrlUtils } from 'utils/discord';
import { useIsLessThan } from 'fxs-utils';

import { IconChevronDown, IconExternalLink, IconX } from '@tabler/icons-react';

import { ContextProps, useDiscordContext } from '../Context/DiscordContext';

const PopupMobile = () => {
	const moreInfoContent = useRef(null);
	const moreInfoLink = useRef(null);
	const popupMobile = useRef(null);
	const { isOpen, setIsOpen } = useDiscordContext() as ContextProps;
	const isLessThan833 = useIsLessThan(833);
	const { user } = useContext(UserContext);
	const { t } = useTranslationsContext();

	useEffect(() => {
		if (!isOpen && isLessThan833) {
			setTimeout(() => {
				moreInfoContent.current?.classList.remove('visible');
				moreInfoLink.current?.classList.remove('hidden');
			}, 600);
		}
	}, [isLessThan833, isOpen]);

	return (
		<>
			<div
				ref={popupMobile}
				className={`${isOpen ? 'open ' : ''}bottom-popup-mobile`}
			>
				<div className='discord-screenshot'>
					<span
						className='close-button'
						onClick={() => setIsOpen(!isOpen)}
					>
						<IconX />
					</span>
					<img
						src='https://editorial.fxsstatic.com/images/TradingStudio/discord-analyst.png'
						alt='Discord Analyst'
					/>
				</div>
				<div className='description'>
					<h3>
						Live community on{' '}
						<span className='discord-brand'>
							Discord <IconDiscord />
						</span>
					</h3>
					<p>
						A place that makes it easy to talk every day with our
						Expert Analysts and other traders.
					</p>
					<span
						ref={moreInfoLink}
						className='more-info'
						onClick={() => {
							moreInfoContent.current.classList.add('visible');
							moreInfoLink.current.classList.add('hidden');
						}}
					>
						More information <IconChevronDown />
					</span>
					<div ref={moreInfoContent} className='more-info-content'>
						<p>
							<strong>Tap into our analysts</strong> to resolve
							ANY question related to your trades, makets moves,
							anything.
						</p>
						<p>
							Direct access to all <strong>insights</strong> and{' '}
							<strong>signals</strong>.
						</p>
						<p>
							<strong>Meet like-minded people</strong> that speak
							the same trading language as you.{' '}
							<strong>Don't trade alone!</strong>
						</p>
						<p>
							Do you need some help?Contact us at{' '}
							<a href='mailto:customercare@fxstreet.com'>
								customercare@fxstreet.com
							</a>
						</p>
					</div>
					<button
						onClick={() =>
							window.open(getDiscordUrlUtils(user.emailEncrypted))
						}
					>
						{t('joinDiscord')}
						<IconExternalLink />
					</button>
					<p className='not-now' onClick={() => setIsOpen(!isOpen)}>
						Not now, maybe later
					</p>
				</div>
			</div>
			<div
				className={`${isOpen ? 'visible ' : ''}background-overlay`}
				onClick={() => setIsOpen(!isOpen)}
			></div>
		</>
	);
};

export default PopupMobile;
